export const ImagePaths = {
    collexter: '../../../assets/icons/apps/collexter.png',
    kainobi: '../../../assets/icons/apps/kainobi.png',
    policybase: '../../../assets/icons/apps/policybase.png',
    schemaytic: '../../../assets/icons/apps/schemaytic.png',
};